







































































































































































































import moment from "moment/moment";
import { mixins } from "vue-class-component";
import ErrorMixin from "@/mixins/errorMixins";
import Component from "vue-class-component";
import { Complement, RecuManager } from "@/shared/recusManager";

@Component({
  components: {},
})
export default class RecusManager extends mixins(ErrorMixin) {
  public datePick: any = new Date().toISOString().substr(0, 10);
  public recus = new Array();
  public monRecu: RecuManager = new RecuManager();
  public loadData = false;
  public editMonRecu = false;
  public search = "";
  public showRecu = false;
  public addRecu = false;
  public headers = [
    { text: "Date", value: "dateFiscale", class: "data-head" },
    { text: "Manager", value: "manager", class: "data-head" },
    { text: "Points", value: "points", class: "data-head" },
    { text: "Service", value: "service", class: "data-head" },
  ];

  public mounted() {
    // console.log("hello");
  }

  public getRecus() {
    this.loadData = true;
    this.$store
      .dispatch("analyses/getRecusManagers", this.datePick)
      .then((response: any) => {
        // console.log("je suis la ");
        this.recus = response;
        this.loadData = false;
        // this.$store.dispatch("login/setLoading", false);
      })
      .catch((error: any) => {
        console.log(error);
        this.setErrorFromTxt(error.toString());
        this.loadData = false;
      });
  }

  public getOne(item: any) {
    // console.log(item);
    this.$store.dispatch("analyses/getOneRecusManagers", item.id).then(
      (data: any) => {
        // console.log(data);
        this.showRecu = true;
        this.monRecu = data;
      },
      (error: any) => {
        console.log(error);
        this.setErrorFromTxt(error.toString());
        this.loadData = false;
      }
    );
  }

  public createRecu() {
    this.monRecu = new RecuManager();
    this.monRecu.complements = [
      {
        cle: "NATURE",
        type: "STRING",
        valeur: "POINTEUSE",
      },
      {
        cle: "POINTS",
        type: "DECIMAL",
        valeur: "0",
      },
      {
        cle: "service",
        type: "DECIMAL",
        valeur: "0",
      },
    ];
    this.addRecu = true;
    console.log(this.monRecu);
  }

  public addMonRecu() {
    this.$store.dispatch("analyses/createOneRecusManagers", this.monRecu).then(
      (data: any) => {
        // console.log(data);
        this.editMonRecu = false;
        this.addRecu = false;
        this.setSuccess(this.$t("ModifSaved").toString());
        this.recus.push(data);
      },
      (error: any) => {
        console.log(error);
        this.setErrorFromTxt(error.toString());
        this.loadData = false;
      }
    );
  }

  public updatePoints(points: any) {
    // console.log(points);
    const recu = this.monRecu.complements.find(
      (cmpl: Complement) => cmpl.cle === "POINTS"
    );
    if (recu) {
      recu.valeur = points;
    }
    // console.log(this.monRecu);
  }

  public updateService(service: any) {
    // console.log(points);
    const recu = this.monRecu.complements.find(
      (cmpl: Complement) => cmpl.cle === "service"
    );
    if (recu) {
      recu.valeur = service;
    }
    // console.log(this.monRecu);
  }

  public saveMonRecu() {
    this.$store.dispatch("analyses/updateOneRecusManagers", this.monRecu).then(
      (data: any) => {
        // console.log(data);
        this.showRecu = false;
        this.editMonRecu = false;
        this.setSuccess(this.$t("ModifSaved").toString());
        const lerecu = this.recus.find(
          (recu: RecuManager) => recu.id === this.monRecu.id
        );
        lerecu.complements = this.monRecu.complements;
      },
      (error: any) => {
        console.log(error);
        this.setErrorFromTxt(error.toString());
        this.loadData = false;
      }
    );
  }

  public formatDateTicket(horodatage: number) {
    const d = moment(horodatage).format("DD/MM/YYYY");
    return d;
  }

  public formatPoints(complements: any) {
    const points = complements.find(
      (cmpl: Complement) => cmpl.cle === "POINTS"
    );
    // console.log(points);
    if (points) {
      return points.valeur;
    } else {
      return 0;
    }
  }

  public formatManager(complements: any) {
    const manager = complements.find(
      (cmpl: Complement) => cmpl.cle === "login"
    );
    // console.log(points);
    if (manager) {
      return manager.valeur;
    } else {
      return "";
    }
  }

  public formatService(complements: any) {
    const points = complements.find(
      (cmpl: Complement) => cmpl.cle === "service"
    );
    // console.log(points);
    if (points) {
      return points.valeur;
    } else {
      return "Non renseigné";
    }
  }
}
